import { useContext, useEffect, useMemo } from 'react'
import { gql, useApolloClient, useQuery } from '@apollo/client'
import {
	ConfirmPlanModification,
	GetQuote,
	GetSubscription,
	Logger,
	Query
} from '@wolfdanepug/common-react'
import { useNavigate } from 'react-router'
import PlanConfirmation from '../../../components/plan/PlanConfirmation'
import { PageContext } from '../../../context/page'

export default function ReviewPlanQuote({ params }: any) {
	const apollo = useApolloClient()
	const { setPage } = useContext(PageContext)
	const navigate = useNavigate()
	const { data: quoteData } = useQuery(gql(GetQuote), {
		variables: {
			id: params.quote
		}
	})

	const confirmPlanModification = async ({ ref }: any) => {
		try {
			await apollo.mutate({
				mutation: gql(ConfirmPlanModification),
				variables: { id: ref }
			})
		} catch (e) {
			Logger.error(e)
		}
	}

	const handleConfirmPlanModificationResponse = () => {
		navigate('/subscription')
	}

	useEffect(() => {
		setPage({
			title: 'Confirm Plan Update',
			description: 'Please confirm the changes to the plan',
			canGoBack: `/subscription/${quote?.plan}`,
			actions: [
				{
					label: 'Confirm',
					event: 'confirm',
					enabled: true
				}
			],
			data: {
				ref: params.quote,
				id: planId,
				weight: quote?.data?.[0].products[0]?.weight,
				products: quote?.data?.[0]?.products.map(({ id }: any) => id)
			},
			handlers: {
				confirm: confirmPlanModification
			},
			response: {
				confirm: handleConfirmPlanModificationResponse
			}
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const quote = useMemo(() => {
		return quoteData?.getQuote?.data[0] || null
	}, [quoteData])

	const planId = useMemo(() => {
		return quote?.plan || null
	}, [quote])

	return (
		<>
			<Query
				doc={GetSubscription}
				component={PlanConfirmation}
				componentProps={{ quote }}
				getData={(data: any) => ({ subscription: data })}
			/>
		</>
	)
}
